/**
 * StakeSelectorData.ts
 */
export class StakeSelectorData {
    constructor() {
        this.index = 0;
        this.values = [];
        this.displayValues = [];
    }
    setIndex(value) {
        this.index = value;
    }
    setValues(value) {
        this.values = value;
    }
    setDisplayValues(value) {
        this.displayValues = value;
    }
    getValue() {
        return this.values[this.index];
    }
    getDisplayValue() {
        return this.displayValues[this.index];
    }
    getIndex() {
        return this.index;
    }
    getValues() {
        return this.values;
    }
    getDisplayValues() {
        return this.displayValues;
    }
}
//# sourceMappingURL=StakeSelectorData.js.map